import BaseModel from "../base/BaseModel.model";
import ProjectType from '@/models/porposal/projectType.Model';
export default class PorposalProjectType extends BaseModel {
  public projectTypeId: number = 0;
  public name:string;

  init() {
    this.name = '';
    this.projectTypeId = null;
  }
}
